import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import Dropdown from "../common/Dropdown";
import Modal from "../common/Modal";
import ResourcesLinks from "../common/ResourcesLinks";
import { pushDatatoAdobeLayer } from '../../analytics/pmiAdobeLog';
import { getAdobeAnalyticsEventObject, getAdobeAnalyticsCustomLinkObj } from '../../analytics/analyticsObject';
const DropdownItemsByRole = {
  general: [
    {
      label: "Profile",
      value: "/account"
    },
    {
      label: "Resources",
      value: "/resourceslinks"
    },
    {
      label: "Glossary",
      value: "/glossary"
    },
    {
      label: "Logout",
      value: "/logout"
    }
  ],
  contentAdmin: [
    {
      label: "Access Manager",
      value: "/admin#/admin/access-manager"
    },
    {
      label: "Category Manager",
      value: "/admin#/admin/category-manager"
    }
  ],
  contentManager: [
    {
      label: "Content Editor",
      value: "/admin#/admin/content-editor"
    }
  ],
  feedbackManager: [
    {
      label: "Feedback Manager",
      value: "/feedback-manager"
    }
  ]
};

function getDropdownItems(isContentAdmin, isContentManager, isFeedbackManager) {
  let items = [];

  if (isContentAdmin) {
    items.push(...DropdownItemsByRole.contentAdmin);
  }

  if (isContentManager || isContentAdmin) {
    items.push(...DropdownItemsByRole.contentManager);
  }

  if (isFeedbackManager || isContentAdmin) {
    items.push(...DropdownItemsByRole.feedbackManager);
  }

  items.push(...DropdownItemsByRole.general);

  return items;
}

const UserMenu = ({
  isAuthenticated,
  isContentAdmin,
  isContentManager,
  isFeedbackManager,
  showMobileToggle = false,
  toggleMenu
}) => {
  const location = useLocation();
  const history = useHistory();

  const [showHomeButton, setShowHomeButton] = useState(false);
  const [isResourceLinksVisible, setIsResourceLinksVisible] = useState(false);

  useEffect(() => {
    const showHomeButton =
      location.pathname === "/account" || location.pathname === "/glossary";
    setShowHomeButton(showHomeButton);
  }, [location.pathname]);

  const userMenuClick = (item) => {
    goToHistoryPage(item)
    if (item === "/resourceslinks") {
      setIsResourceLinksVisible(true)
    } else {
      history.push(item)
    }
  }
  const goToHistoryPage = (item) => {
    adobeCustomLog(item);

  };

  const adobeCustomLog = (path) => {
    path = path.replace('/', '');
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(path, "dropdownmenuitem", "/" + path);;
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false, loginData: false
    });
  }
  const eventTrackLogin = (path) => {
    path = path.replace('/', '');
    let customEventObj = getAdobeAnalyticsEventObject("linkClick", "linkClick");
    let customLObj = getAdobeAnalyticsCustomLinkObj(path, "header", "/" + path);;
    pushDatatoAdobeLayer({
      customLinkData: { ...customEventObj, ...customLObj },
      pageData: false,
      adobePushTracking: false, loginData: false
    });
  }
  return (
    <div className="flex items-center text-black">
      {isResourceLinksVisible && (
        <Modal onClose={() => setIsResourceLinksVisible(false)} onClickOutside={true}>
          <ResourcesLinks />
        </Modal>
      )}
      {isAuthenticated ? (
        <div className="flex md:flex-row md:items-center flex-no-wrap">
          {showHomeButton && (
            <Link to="/home">
              <span className="text-lg text-black no-underline font-medium mr-1 mr-3 cursor-pointer">
                <span className="hidden md:inline-block mr-1">Home</span>
                <div className="inline-block">
                  <i className="fas fa-home text-2xl align-middle mb-1" />
                </div>
              </span>
            </Link>
          )}
          <div className="md:mr-0 lg:mr-3" adoberegion='dropdownmenuitems'>
            <Dropdown
              id="login_widget"
              items={getDropdownItems(
                isContentAdmin,
                isContentManager,
                isFeedbackManager
              )}
              buttonLabel={
                <span className="text-lg text-black no-underline font-medium mr-1 md:mr-0">
                  <span className="hidden md:inline-block mr-3 md:mr-0 xl:mr-2">Menu</span>
                  <div className="inline-block">
                    <i className="fa fa-bars text-2xl align-middle mb-1" />
                  </div>
                </span>
              }
              onClickItem={item => userMenuClick(item.value)}
              itemsStyles="py-2 rounded-sm shadow-md"
            />
          </div>
        </div>
      ) : (
        <div adoberegion="header">
          <span className="hidden md:inline-block pr-2">
            Already Registered?
          </span>
          <Link
            to="/login"
            className="text-base inline-block no-underline text-black font-bold hover:text-black"
           onClick={() => {{eventTrackLogin('login')}}}
          >
            Login
          </Link>
        </div>
      )}
      {showMobileToggle && (
        <div className="md:mx-4">
          <button
            onClick={toggleMenu}
            className="inline-block md:hidden bg-white rounded px-3 py-2 text-blue font-bold text-lg"
          >
            &#9776;
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
